<template>
    <div v-if="this.model" class="dcv_container">
      <!-- <customer v-if="this.model.customer" :customer="this.model.customer" :enable_details="false">
      </customer> -->
      <order v-if="fullorder" :order="fullorder">
      </order>
      <agency v-if="this.model.offer.distributed_product.agency" :agency="this.model.offer.distributed_product.agency"></agency>
    </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import Agency from "./Details/ValidationRequestable/Offer/Agency"
import Customer from "./Details/ValidationRequestable/Customer"
import Order from "./Details/ValidationRequestable/Order"

export default {
  name:"ModelDomiciliationContractValidation",
  props:["model"],

  components:{
    Agency,
    Customer,
    Order,
  },

  computed:{
    ...mapState('demands', ['orders']),

    fullorder(){
      var tmp = _.find(this.orders, (order) => order.id == this.model.order.id)
      if (tmp)
        return tmp
      else {
        return false
      }
    },

    get_suborders(){
      if (this.fullorder)
        return this.fullorder.suborders
      return false
    }

  },

  methods:{
    ...mapActions('demands', ['get_options'])
  },

  created() {
    this.get_options({order_id:this.model.order.id})
  },

}
</script>
<style scoped>
.dcv_container {
  display: flex;
  border: 1px solid lightgray;
}
.dcv_container > div:first-child { border-right: 1px solid lightgray; }

@media screen and (max-width: 800px) {
  .dcv_container {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/ModelDomiciliationContractValidation.vue